import GetApi from '../../../common/api/get'
import { validate } from '../utils'

export const FETCH_ROOM_GROUPS = "FETCH_ROOM_GROUPS"
export const FETCH_ROOM_GROUPS_SUCCESS = "FETCH_ROOM_GROUPS_SUCCESS"
export const FETCH_ROOM_GROUPS_FAILURE = "FETCH_ROOM_GROUPS_FAILURE"
export const SET_STATE_SEARCH = 'SET_STATE_SEARCH'

export const fetchRoomGroups = () => ({
  type: FETCH_ROOM_GROUPS
})

export const fetchRoomGroupsSuccess = payload => ({
  type: FETCH_ROOM_GROUPS_SUCCESS,
  payload
})

export const fetchRoomGroupsFailure = error => ({
  type: FETCH_ROOM_GROUPS_FAILURE,
  payload: { error }
})

export function setState(params) {
  return {
    type: 'SET_STATE_SEARCH',
    params
  }
}

export function getRoomGroups(query = {}) {
  return async (dispatch, getState) => {
    const getApi = new GetApi()

    dispatch(fetchRoomGroups())
    const condition = validate(query)

    return getApi.execute(routeUrlHelper.searchPath(condition, { arrayFormat: 'bracket' }))
      .then(res => {
        const { destination = {} } = res.body

        dispatch(setState(condition))

        return dispatch(fetchRoomGroupsSuccess(
          Object.assign({
            total_count: 0
          }, res.body, {
            destination: destination.name || condition.destination,
            lat: destination.lat,
            lon: destination.lon,
            radius: destination.radius
          }))
        )
      })
      .catch(error => {
        dispatch(fetchRoomGroupsFailure(error))
      })
  }
}

export function getRoomGroupsForMap(tile, query = {}) {
  return async (dispatch, getState) => {
    const state = getState()
    const bounds = tile.toString()
    const cache = state.search.tiles.get(tile)

    if (cache) {
      return Promise.resolve({ tile, roomGroups: cache })
    }

    return (new GetApi()).execute(routeUrlHelper.searchPath({ ...query, bounds }, { arrayFormat: 'bracket' }))
      .then(({ body: { room_groups: roomGroups = [] } = {} }) => {
        state.search.tiles.set(tile, roomGroups)
        return { tile, roomGroups }
      })
      .catch(error => {
        return { tile, error }
      })
  }
}
